// Attentive's Jira instance. Jira keys (e.g. "A1EE-334") link to the issue browse page.
const JIRA_BROWSE_BASE = 'https://attentivemobile.atlassian.net/browse';

export function jiraIssueUrl(key: string): string {
  return `${JIRA_BROWSE_BASE}/${encodeURIComponent(key)}`;
}
